// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";
import Nestable from "react-nestable";

// Import components
import {NestableItem} from "../../components/cards/nestableItem";
import PageWrapper from "../../components/pageContentViews/pageWrapper";
import PageHeader from "../../components/pageContentViews/pageHeader";

// Import utils
import {mapStateToProps} from "../../redux/mapStateToProps";
import {changeStateField, deleteItem} from "../../utils/helperFunctions";
import {
    GetSliders,
    DeleteSliderById,
    UpdateSlidersPositions,
    setSliderType
} from "../../redux/actions";
import {CustomTabs} from "../../components/uiElements/Tabs";


const pageTabs = [
    {
        name: "Գլխավոր",
        key: "HOME"
    },
    {
        name: "Բաններ",
        key: "BANNER"
    },
]


class Slider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: pageTabs[0].key,
        }
        this.changeTab = this.changeTab.bind(this);
        this.deleteSlider = deleteItem.bind(this, props.DeleteSliderById, 'սլայդերը');
        this.onPositionChange = this.onPositionChange.bind(this);
        props.setSliderType(pageTabs[0].key)
    }

    componentDidMount() {
        this.props.GetSliders(pageTabs[0].key);
        this.props.GetSliders(pageTabs[1].key);
    }

    changeTab(tab) {
        let {sliders} = this.props;
        this.setState({
            activeTab:tab,
        })
        this.props.setSliderType(tab)
        !sliders[tab]?.length && this.props.GetSliders(tab);
    }

    getNestableItems(list, parent = null) {
        const {activeTab} = this.state;
        const items = [];
        list && !!list.length && list.forEach((item, index) => {
            items.push({
                id: item.id,
                index: index,
                title: item.title || " ",
                withImage: true,
                isHidden: item.isHidden,
                path: item?.mediaMain?.path,
                link: {
                    pathname: `slider/edit/${item.id}`,
                },
                deleteCb: () => this.deleteSlider(item.id, activeTab),
                children: []
            })
        });
        return items;
    }

    async onPositionChange(items, item) {
        const movedSliderId = item.id;
        const {activeTab} = this.state;
        const {sliders} = this.props;
        const positionedItems = items.map((item, index) => {
            return {id: item.id, position: index}
        });
        if (~sliders[activeTab].findIndex(m => m.id === movedSliderId) &&
            ~positionedItems.findIndex(m => m.id === movedSliderId)) {
            // first level menu was re-positioned in first level
            await this.props.UpdateSlidersPositions(positionedItems);
            this.props.GetSliders(activeTab);
        }
    }

    render() {
        let {sliders} = this.props;
        let { activeTab } = this.state;

        let items = this.getNestableItems(sliders[activeTab]);
        return <PageWrapper pageTitle={'Սլայդեր'}>
            <PageHeader linkTitle={"Ավելացնել"}
                        addingLink={`/slider/add`}/>
           {/* <CustomTabs changeTab={this.changeTab}
                        tabsList={pageTabs}
                        activeTab={activeTab}/>*/}
            {items && items.length !== 0 &&
            <Nestable
                items={items}
                maxDepth={1}
                onChange={this.onPositionChange}
                renderItem={NestableItem}
            />}
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetSliders,
    setSliderType,
    DeleteSliderById,
    UpdateSlidersPositions
};

export default connect(mapStateToProps, mapDispatchToProps)(Slider);
